/******************************************************************************
 * FILE:
 * src/modules/wms/services/wmsMyWorkService.js
 *
 * FEATURE:
 * My Work API client
 ******************************************************************************/

import axiosClient from "../../../api/axiosClient";

async function getMyWork(params = {}) {
  const res = await axiosClient.get(
    "/api/wms/my-work",
    {
      params,
    }
  );

  return res.data?.data || {
    summary: {},
    attention: {},
    work: [],
    my_escalations: [],
    sla_distribution: [],
    timeline: [],
  };
}

const wmsMyWorkService = {
  getMyWork,
};

export default wmsMyWorkService;
